import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

// PrimeNG reads the same tokens as Tailwind (src/styles/_tokens.scss); no colors are defined here.
const mix = (pct: number, base: 'white' | 'black') => `color-mix(in srgb, hsl(var(--primary)) ${pct}%, ${base})`;

const neutral = Object.fromEntries(
  [50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950].map((k) => [k, `{neutral.${k}}`]),
);

export const RegistroPreset = definePreset(Lara, {
  primitive: {
    borderRadius: {
      xs: 'calc(var(--radius) - 8px)',
      sm: 'calc(var(--radius) - 4px)',
      md: 'calc(var(--radius) - 2px)',
      lg: 'var(--radius)',
      xl: 'calc(var(--radius) + 4px)',
    },
  },
  semantic: {
    primary: {
      50: mix(8, 'white'),
      100: mix(16, 'white'),
      200: mix(32, 'white'),
      300: mix(52, 'white'),
      400: mix(76, 'white'),
      500: 'hsl(var(--primary))',
      600: 'hsl(var(--primary-hover))',
      700: mix(80, 'black'),
      800: mix(65, 'black'),
      900: mix(50, 'black'),
      950: mix(35, 'black'),
    },
    colorScheme: {
      light: {
        surface: { 0: 'hsl(var(--card))', ...neutral },
      },
    },
  },
});
